
import React, { useEffect, useState, forwardRef, useRef } from 'react';
import { Modal } from "reactstrap";
import { addActivity, getLatestNotesForUser } from '../../apiCalls';
import { ACTIVITY_TYPES } from '../../constants';
import { getScreenType } from '../../utils';
import './NotesModal.css';

const NotesModal = forwardRef(({
	displayModal, 
	setDisplayModal,
	anonymousUserId,
	researchId, 
	projectMode
}, ref) => {
	const [previousNotes, setPreviousNotes] = useState('');
	const [notesContent, setNotesContent] = useState('');
	const contentRef = useRef(null);

	// Fetch notes when modal opens
	useEffect(() => {
		const fetchNotes = async () => {
			if (displayModal && anonymousUserId) {
				const tempNotes = await getLatestNotesForUser(anonymousUserId);
				setPreviousNotes(tempNotes);
				setNotesContent(tempNotes);
				if (contentRef.current) {
					contentRef.current.innerText = tempNotes || '';
				}
			}
		};
		fetchNotes();
	}, [anonymousUserId, displayModal]);

	const handleSave = async () => {
		console.log('Saving notes...');
		try {
			await addActivity(
				anonymousUserId,
				researchId,
				ACTIVITY_TYPES.SAVE_NOTES,
				null,
				null,
				null,
				notesContent,
				projectMode,
				getScreenType()
			);
			console.log('Notes content:', notesContent);
			setPreviousNotes(notesContent);
			return true;
		} catch (error) {
			console.error("Error saving notes:", error);
			return false;
		}
	};

	const handleClose = async () => {
		console.log('Logging close activity...');
		await addActivity(
			anonymousUserId,
			researchId,
			ACTIVITY_TYPES.CLOSE_NOTES,
			null,
			null,
			null,
			null,
			projectMode,
			getScreenType()
		);
	};

	const handleCloseModal = async () => {
		try {
			console.log('Starting modal close process...');
			const saveSuccess = await handleSave();
			if (saveSuccess) {
				console.log('Notes saved successfully');
				await handleClose();
				console.log('Close activity logged');
				setDisplayModal(false);
				console.log('Modal closed successfully');
			}
		} catch (error) {
			console.error("Error closing modal:", error);
		}
	};

	const handleInput = (event) => {
		setNotesContent(event.currentTarget.innerText);
	};

	return (
		<Modal
			ref={ref}
			isOpen={displayModal}
			toggle={handleCloseModal}
			backdrop={true}
			keyboard={true}
			className="notes-modal"
		>
			<header className="notes-header">
				<label>Notes</label>
			</header>
			<div
				ref={contentRef}
				className="notes-body"
				contentEditable
				onInput={handleInput}
				suppressContentEditableWarning={true}
				role="textbox"
				aria-multiline="true"
			/>
			<button
				onClick={handleCloseModal}
				className="notes-save-button"
			>
				Save & Close
			</button>
		</Modal>
	)
})

export default NotesModal